/* eslint-disable import/no-cycle */
/* eslint-disable no-restricted-syntax */
import { fromJS } from "immutable";
import ActionTypes from "../../constants/action-types";
import AppConfig from "../../constants/config";
import content from "../../constants/content";
import triggerSimpleAjax from "../../helper/httpHelper";
import { projectMigrationHelper } from "../../helper/jsonMigrationHelper";
import proceedWait from "../../helper/proceedWait";
import uuid from "../../helper/uuid";
import { addNotification } from "./notificationUtils";
import { addCordsToSubtitle, updateAutoSubtitle } from "./subtitleUtils";
import { removeInvalidProjectKeys } from "../../helper/projectValidation";
import { getTextBounds } from "../../containers/text/TextHelper";
import { getSubtitlesFontToLoad, loadSubtitleFontFamily } from "../../helper/fontLoadHelper";
import { updateIntroOutroText, applyFlipInitial } from "./appUtils";
// import { getRandomInt } from "../../helper/formateDate";
import openUrl from "../../helper/openUrl";
import { sendSocketMessage } from "../../socket";
import socketChannels from "../../constants/socket-channels";

const { API_URL, API } = AppConfig;

export const saveProject = (projectId, details) => {
  return new Promise((res, rej) => {

    triggerSimpleAjax(
      `${API_URL}${API.SAVE_PROJECT_REST}`,
      "POST",
      false,
      {
        projectId,
        data: removeInvalidProjectKeys(details),
      },
      (args) => {
        res(args);
      },
      (err) => {
        rej(err);
      }
    );
  });
};

export async function getSubtitleData(params) {
  const { subtitleId, projectId } = params;
  return new Promise((resolve, reject) => {
    const body = { subtitleId, projectId };
    const onSuccess = async (res) => {
      if (res.status === "error") {
        return reject(new Error(content.FAILED_TO_LOAD_SUBTITLE_DATA))
      }
      return resolve(res);
    };
    const onError = () =>
      reject(new Error(content.FAILED_TO_LOAD_SUBTITLE_DATA));
    triggerSimpleAjax(
      `${API_URL}${API.SUBTITLE.GET}`,
      "POST",
      false,
      body,
      onSuccess,
      onError
    );
  });
}

/**
 * 
 * @param {[List]} subtitleList 
 * @param {{enterStart: number, exitEnd: number}} target 
 * @param {number} left 
 * @param {number} right 
 * @param {[number]} result 
 * @returns {[number]}
 */
const findIndexes = (subtitleList, target, left, right, result = []) => {
  if (left > right) return result;

  const mid = Math.floor((left + right) / 2);

  /**
   * @type {{enterStart: number, exitEnd: number}}
   */
  const midSubtitle = subtitleList.get(mid);

  const inBtwn = midSubtitle.get("enterStart") >= target.enterStart && midSubtitle.get("exitEnd") <= target.exitEnd; // in between
  const leftX = midSubtitle.get("exitEnd") >= target.enterStart && midSubtitle.get("enterStart") <= target.enterStart; // left intersection
  const rightX = midSubtitle.get("enterStart") <= target.exitEnd && midSubtitle.get("exitEnd") >= target.exitEnd; // right intersection

  const searchThroughRight = target.exitEnd > midSubtitle.get("enterStart");

  if (inBtwn || leftX || rightX) {
    result.push(mid);
    findIndexes(subtitleList, target, left, mid - 1, result);
    findIndexes(subtitleList, target, mid + 1, right, result);
  } else if (searchThroughRight) {
    findIndexes(subtitleList, target, mid + 1, right, result); // Search right
  } else {
    findIndexes(subtitleList, target, left, mid - 1, result); // Search left
  }
  return result; // Return all valid indices
}

function updateExitEndIfRestricted(data) {
  if (data.workspaceItems) {
    Object.values(data.workspaceItems).forEach(item => {
      if (item.isRestrict) {
        item.exitStart = item.exitEnd;
        item.exitEnd = item.maxDuration;
      }
    });
  }
  return data;
}

export function setProjectDetails(id, userResponse, isApp = false, isPublish = false) {
  const apiUrl = `${API_URL}${isApp ? API.GET_PROJECT : isPublish ? API.GET_RENDER_PROJECT : API.PREVIEW_PROJECT}`;

  return (dispatch, getState) => {
    const noPermission = async (access, url) => {
      dispatch(
        addNotification({
          id: uuid(),
          toastType: "WARNING",
          description: `You don't have ${access} access to this project.`,
        })
      );
      await proceedWait(2000);
      window.location.href = `${url}`;
    };
    return new Promise((res, rej) => {
      triggerSimpleAjax(
        apiUrl,
        "POST",
        true,
        { [isPublish ? "exportid" : "projectId"]: id },
        async (response) => {
          let { permission } = response;
          const { modified } = response;
          permission = isPublish ? 1 : permission
          const { project, subtitle_data: subtitleData, projectId = "" } = response;
          if (!project) {
            openUrl(`${API_URL}dashboard/`, true);
          }
          const { width, height } = project;
          let titleTextPayLoad;
          const { titletext } = project.workspaceItems || {};
          const isRectNotFit = Object.keys(project.workspaceItems || {}).some((key) => {
            const ele = project.workspaceItems[key];
            return ele.type === "SHAPE" && ele.mappingTextId && ele.height === null
          })
          if (titletext) {
            const { isVerified } = titletext.textData.formats.others; /** @desc for the first time we verify if the titleText is properly fit to the space */
            if (!isVerified) {
              const maxWidth = titletext.width;
              const { family: fontFamilyName } = titletext.textData.formats.others;
              const { fontFamily } = titletext.textData.formats.containerStyle;
              const textData = {
                fontFamilyName, fontFamily,
                others: {
                  isUserFont: titletext.textData.formats.others.isUserFont,
                  cssUrl: titletext.textData.formats.others.cssUrl
                }
              }
              const fontToLoad = getSubtitlesFontToLoad(undefined, fromJS([]), textData);
              if (fontToLoad.length) {
                const sampleText = titletext.textData.htmlText;
                await loadSubtitleFontFamily(fontToLoad, sampleText);
              }
              const textBounds = getTextBounds(fromJS(titletext.textData), maxWidth);
              const paddOffSet = 15;
              const newY = (height / 2) - (textBounds.height / 2) - paddOffSet;
              const newHeight = textBounds.height + paddOffSet * 2;
              titletext.textData.formats.others.isVerified = true;
              const shapeProps = {};
              if (titletext.type === "SHAPE") {
                shapeProps.yRatio = (((newHeight / 2) - textBounds.height / 2) / newHeight) * 100;
                shapeProps.heightRatio = (textBounds.height / newHeight) * 100;
              }
              project.workspaceItems.titletext = { ...titletext, y: newY, height: newHeight, ...shapeProps };
              const { x, y, width: txtWidth, height: txtHeight } = project.workspaceItems.titletext;
              titleTextPayLoad = {
                container: "workspaceItems",
                selectedItem: "titletext",
                isTyping: false,
                toUpdate: {
                  textData: titletext.textData,
                  x, y, width: txtWidth, height: txtHeight,
                  ...shapeProps
                }
              }
            }
          }
          if (subtitleData && subtitleData.length) {
            const defaultSubtitle = subtitleData.find(
              (subtitle) => subtitle.isActive !== false
            );
            try {
              const result = await getSubtitleData({
                projectId: isPublish ? projectId : id,
                subtitleId: defaultSubtitle.subtitleId,
              });
              project.subtitle = result.subtitle;
              project.defaultSubtitle = defaultSubtitle.subtitleId;
              project.subtitleData = subtitleData;
              let hasValidCords = false;
              let isAllEmpty = true;
              for (const [, subtitleMap] of Object.entries(result.subtitle.data)) {
                for (const [, subtitleItem] of Object.entries(subtitleMap)) {
                  isAllEmpty = false;
                  if (Number.isFinite(subtitleItem.x) && Number.isFinite(subtitleItem.y) && Number.isFinite(subtitleItem.width) &&
                    Number.isFinite(subtitleItem.height) && subtitleItem.width !== 0 && subtitleItem.height !== 0) {
                    hasValidCords = true;
                    break;
                  }
                }
              }
              if (!hasValidCords && !isAllEmpty) {
                const { updatedSubtitles, textStyles, textEffects } =
                  await addCordsToSubtitle(result.subtitle, {
                    loadedFonts: fromJS([]),
                    workspaceWidth: width,
                    workspaceHeight: height,
                  });
                await updateAutoSubtitle(
                  updatedSubtitles,
                  isPublish ? projectId : id,
                  defaultSubtitle.subtitleId,
                  textStyles,
                  textEffects,
                  Boolean(result.subtitle.position)
                );
                project.subtitle.data = updatedSubtitles.toJS();
                delete project.subtitle.position;
              }
            } catch (err) {
              project.subtitle = undefined;
              dispatch(
                addNotification({
                  id: uuid(),
                  toastType: "WARNING",
                  description: err.message || content.WENT_WRONG,
                })
              );
            }
          }
          if (isRectNotFit) {
            const shapeItems = Object.keys(project.workspaceItems).filter(key => {
              const ele = project.workspaceItems[key];
              return ele.type === "SHAPE" && ele.mappingTextId && ele.height === null;
            });
            const textItems = Object.keys(project.workspaceItems).filter(key => {
              const ele = project.workspaceItems[key];
              return ele.type === "TEXT" && shapeItems.find(shape => project.workspaceItems[shape].mappingTextId === ele.id);
            });

            for (const key of shapeItems) {
              const shapeEle = project.workspaceItems[key];
              const mappingText = textItems.map(textKey => project.workspaceItems[textKey]).find(text => text.id === shapeEle.mappingTextId);
              if (mappingText) {
                const { width } = project;
                const maxWidth = width;
                const { family: fontFamilyName } = mappingText.textData.formats.others;
                const { fontFamily } = mappingText.textData.formats.containerStyle;
                const textData = {
                  fontFamilyName, fontFamily,
                  others: {
                    isUserFont: mappingText.textData.formats.others.isUserFont,
                    cssUrl: mappingText.textData.formats.others.cssUrl
                  }
                }
                const fontToLoad = getSubtitlesFontToLoad(undefined, fromJS([]), textData);
                await loadSubtitleFontFamily(fontToLoad, mappingText.textData.htmlText);
                const textBounds = getTextBounds(fromJS(mappingText.textData), maxWidth);
                const paddOffSet = 20;
                const newHeight = textBounds.height + paddOffSet * 2;
                mappingText.textData.formats.others.isVerified = true;
                const shapeProps = {};
                // eslint-disable-next-line no-alert
                if (shapeEle.type === "SHAPE") {
                  shapeProps.yRatio = (((newHeight / 2) - textBounds.height / 2) / newHeight) * 100;
                  shapeProps.heightRatio = (textBounds.height / newHeight) * 100;
                  shapeProps.height = newHeight;
                }
                project.workspaceItems[key] = { ...shapeEle, ...shapeProps };
                sendSocketMessage(socketChannels.S_MOVE_UPDATE, {
                  data: {
                    currentContainer: "workspaceItems",
                    workspaceChildren: {},
                    workspaceItems: {
                      [shapeEle.id]: {
                        height: shapeProps.height
                      }
                    }
                  }
                });
              }
            }
          }
          let dimensionName = "";
          if (width > height) {
            dimensionName = "horizontal";
          } else if (width === height) {
            dimensionName = "square";
          } else {
            dimensionName = "vertical";
          }
          let projectData;
          if (project.scenes?.length) {
            projectData = projectMigrationHelper(project);
            saveProject(isPublish ? projectId : id, projectData).then(() => {
              dispatch({
                type: ActionTypes.ADD_NOTIFICATION,
                payload: {
                  id: uuid(),
                  toastType: "SUCCESS",
                  description: "Project has been Migrated successfully.",
                },
              });
            });
          } else {
            projectData = project;
          }

          const applyFlipItems = [];
          const workspaceItemsLs = Object.entries(projectData.workspaceItems);
          let hasNullCordsTexts = false; // text Items with null cordinates [can be emojis 😃]
          if (workspaceItemsLs.length) {
            hasNullCordsTexts = workspaceItemsLs.some(([key, value]) => {
              if (key !== "titletext") {
                const { x, y, type, yLoc, xLoc } = value;
                if (type === "TEXT" && (yLoc !== undefined && yLoc !== null) && (xLoc !== undefined && xLoc !== null) && (x === null || y === null)) {
                  return true
                }
              }
              return false;
            });
          }

          projectData = updateExitEndIfRestricted(projectData);

          if (isApp && !permission) {
            noPermission("edit", `${window.location.origin}/preview/${id}`);
          }
          dispatch({
            type: ActionTypes.SET_USER_DATA,
            payload: {
              isLoggedIn: true,
              projectId: isPublish ? projectId : id,
              dimensionName,
              permission,
              ...userResponse,
              modified
            },
          });
          dispatch({
            type: ActionTypes.SET_PROJECT,
            payload: {
              ...projectData,
            },
          });
          const localSubtitleList = getState().projectDetails.get("localSubtitle").toList();
          if (hasNullCordsTexts) {
            workspaceItemsLs.forEach(([key, value]) => {
              if (key !== "titletext") {
                const { x, y, type, yLoc, xLoc, textData } = value;
                if (type === "TEXT" && (yLoc !== undefined && yLoc !== null) && (xLoc !== undefined && xLoc !== null) && (x === null || y === null)) {
                  let result = [];
                  if (localSubtitleList.size)
                    result = findIndexes(localSubtitleList, { enterStart: value.enterStart, exitEnd: value.exitEnd }, 0,
                      localSubtitleList.size - 1, []);

                  const { width: itemWidth, height: itemHeight } = getTextBounds(fromJS(textData), width);
                  let newY;
                  if (result.length) {
                    const maxY = result.reduce((prevY, listIndex) => {
                      const subtitleY = localSubtitleList.getIn([listIndex, "y"]) || height * yLoc;
                      return Math.min(prevY, subtitleY);
                    }, Infinity)
                    newY = maxY - itemHeight - 5;
                  } else {
                    newY = height * yLoc - (itemHeight / 2);
                  }
                  const newX = width * xLoc - (itemWidth / 2);
                  const toUpdate = { x: newX, y: newY, width: itemWidth, height: itemHeight };
                  applyFlipItems.push({
                    container: "workspaceItems",
                    id: key,
                    data: toUpdate
                  })
                }
              }
            })
          }

          if (applyFlipItems.length) {
            dispatch(applyFlipInitial(applyFlipItems));
          }
          if (titleTextPayLoad) { /** @Note always keep the dispatch in the bottom */
            dispatch(updateIntroOutroText(titleTextPayLoad));
          }
          res(response);
        },
        async (error) => {
          if (!isApp) {
            noPermission("view", AppConfig.API_URL);
          }
          dispatch({
            type: ActionTypes.SET_USER_DATA,
            isLoggedIn: true,
            ...userResponse,
          });
          rej(error);
        }
      );
    });
  };
}

export const setUserPaymentDetails = (id) => {
  const apiUrl = `${API_URL}${API.USER_PROJECT_DETAILS}`;

  return (dispatch) =>
    new Promise((res, rej) => {
      triggerSimpleAjax(
        apiUrl,
        "POST",
        true,
        { projectId: id },
        (response) => {
          dispatch({
            type: ActionTypes.SET_PAYMENT_DETAILS,
            payload: { ...response },
          });
        },
        (err) => {
          dispatch(
            addNotification({
              id: uuid(),
              toastType: "WARNING",
              description:
                err.message || content.FAILED_TO_GET_USER_PROJECT_DETAILS,
            })
          );
          rej(err);
        }
      );
    });
};

export function setAnimoProjectDetails(id, isSubtitle) {
  const apiUrl = `${API_URL}${API.GET_ANIMO_PROJECT}`;
  return (dispatch) =>
    new Promise((res, rej) => {
      triggerSimpleAjax(
        apiUrl,
        "POST",
        true,
        {
          projectId: id,
        },
        async (response) => {
          const { project, subtitle_data: subtitleData } = response;
          const { width, height } = project;
          if (subtitleData && subtitleData.length) {
            const defaultSubtitle = subtitleData.find(
              (subtitle) => subtitle.isActive !== false
            );
            try {
              const result = await getSubtitleData({
                projectId: id,
                subtitleId: defaultSubtitle.subtitleId,
              });
              project.subtitle = result.subtitle;
              project.defaultSubtitle = defaultSubtitle.subtitleId;
              let hasValidCords = false;
              let isAllEmpty = true;
              for (const [, subtitleMap] of Object.entries(result.subtitle.data)) {
                for (const [, subtitleItem] of Object.entries(subtitleMap)) {
                  isAllEmpty = false;
                  if (Number.isFinite(subtitleItem.x) && Number.isFinite(subtitleItem.y) && Number.isFinite(subtitleItem.width) &&
                    Number.isFinite(subtitleItem.height) && subtitleItem.width !== 0 && subtitleItem.height !== 0) {
                    hasValidCords = true;
                    break;
                  }
                }
              }
              if (!hasValidCords && !isAllEmpty) {
                const { updatedSubtitles, textStyles, textEffects } =
                  await addCordsToSubtitle(result.subtitle, {
                    loadedFonts: fromJS([]),
                    workspaceWidth: width,
                    workspaceHeight: height,
                  });
                await updateAutoSubtitle(
                  updatedSubtitles,
                  id,
                  defaultSubtitle.subtitleId,
                  textStyles,
                  textEffects
                );
                project.subtitle.data = updatedSubtitles.toJS();
              }
            } catch (err) {
              project.subtitle = undefined;
              dispatch(
                addNotification({
                  id: uuid(),
                  toastType: "WARNING",
                  description: err.message || content.WENT_WRONG,
                })
              );
            }
          }
          dispatch({
            type: ActionTypes.SET_USER_DATA,
            payload: {
              isLoggedIn: true,
              projectId: id,
            },
          });
          dispatch({
            type: ActionTypes.SET_PROJECT,
            payload: {
              ...project,
            },
            isAnimoSubtitle: isSubtitle,
          });
          res(response);
        },
        (error) => {
          dispatch({
            type: ActionTypes.SET_USER_DATA,
            isLoggedIn: true,
          });
          dispatch(
            addNotification({
              id: uuid(),
              toastType: "WARNING",
              description:
                error.message || content.FAILED_TO_GET_PROJECT_DETAILS,
            })
          );
          rej(error);
        }
      );
    });
}

export function getUserDetails() {
  const apiUrl = `${API_URL}${API.USER_DETAILS}`;
  return new Promise((res, rej) => {
    triggerSimpleAjax(
      apiUrl,
      "POST",
      true,
      {},
      (response) => {
        res(response);
      },
      (error) => {
        rej(error);
      }
    );
  });
}

export function getCredits() {
  const apiUrl = `${API_URL}${API.GET_CREDITS}`;
  return (dispatch, getState) => new Promise((res, rej) => {
    let cc = "US"
    try {
      cc = getState().app.getIn(["ipConfig", "country_code"]);
    } catch (e) {
      cc = "US";
    }
    triggerSimpleAjax(
      apiUrl,
      "POST",
      true,
      {
        cc
      },
      (response) => {
        dispatch({
          type: ActionTypes.SET_CREDITS,
          payload: response,
        });
        res(response);
      },
      (error) => {
        rej(error);
      }
    );
  })
}

export function getTeamDetails() {
  const apiUrl = `${API_URL}${API.TEAM_DETAILS}`;
  return new Promise((res, rej) => {
    triggerSimpleAjax(
      apiUrl,
      "POST",
      true,
      {},
      (response) => {
        res(response);
      },
      (error) => {
        rej(error);
      }
    );
  });
}

export function switchTeam(dataT) {
  const apiUrl = `${API_URL}${API.SWITCH_TEAM}`;
  return new Promise((res, rej) => {
    triggerSimpleAjax(
      apiUrl,
      "POST",
      true,
      { dataT },
      (response) => {
        res(response);
      },
      (error) => {
        rej(error);
      }
    );
  });
}

export function getProjectInfo(id) {
  const apiUrl = `${API_URL}${API.GET_PROJECT_INFO}`;
  return (dispatch) => new Promise((res, rej) => {
    triggerSimpleAjax(
      apiUrl,
      "POST",
      true,
      {
        projectId: id
      },
      (response) => {
        dispatch({
          type: ActionTypes.SET_PROJECT_INFO,
          payload: { ...response }
        });
        res(response);
      },
      (e) => {
        rej(e);
      }
    );
  });
}

export async function insertSubtitle(reqBody) {
  return new Promise((resolve, reject) => {
    const onSuccess = async (res) => {
      if (!res.success) {
        return reject(new Error(content.FAILED_TO_IMPORT_SUBTITLE_DATA));
      }
      return resolve(res);
    };
    const onError = () =>
      reject(new Error(content.FAILED_TO_IMPORT_SUBTITLE_DATA));
    triggerSimpleAjax(
      `${API_URL}${API.SUBTITLE.INSERT}`,
      "POST",
      false,
      reqBody,
      onSuccess,
      onError
    );
  });
}

export function setJobtInfo(payload) {
  const apiUrl = `${API_URL}${API.UPDATE_JOB_INFO}`;
  return (dispatch) => new Promise((res, rej) => {
    triggerSimpleAjax(
      apiUrl,
      "POST",
      false,
      payload,
      (response) => {
        const { jobRequest } = response
        dispatch({
          type: ActionTypes.SET_PROJECT_INFO,
          payload: { jobRequest }
        });
        res(response);
      },
      (e) => {
        rej(e);
      }
    );
  });
}